<template >
    <div class="version" v-if="hasRoleToCreateClubs">
        <el-button type="text" @click="centerDialogVisible = true">{{versionApp}}</el-button>

        <el-dialog title="Versiones" :visible.sync="centerDialogVisible" width="80%" center>
            <el-collapse v-model="activeNames" >
                <el-collapse-item
                    v-for="(item, index) in versionList"
                    :key="item.title"
                    :label="item.title"
                    :name="index"
                    :title="item.title"
                >
                <ol>
                <li
                 v-for="(item, index) in item.changeList"
                    :key="index"
                > {{item }}</li>
              
               </ol>
                </el-collapse-item>
            </el-collapse>
            <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogVisible = false">Cerrar</el-button>
                <!-- <el-button type="primary" @click="centerDialogVisible = false">Confirm</el-button> -->
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

/* eslint-disable */
export default {
    name: "VersionApp",
    data() {
        return {
            versionApp: "V0.9.9.1",
            centerDialogVisible: false,
            activeNames: [],
            versionList: [
                {
                    title: "V0.1",
                    changeList: [
                        "Creación/edición de clubs, equipos y jugadores.",
                        "Sistema de envío de invitaciones.",
                        "Login en función del rol."
                    ]
                },
                {
                    title: "V0.2",
                    changeList: [
                        "Corrección creación de un equipo desde la vista del club (autoseleccion del club en el formulario del equipo).",
                        "Corrección creación de un jugador desde la vista del equipo (autoseleccion del equipo en el formulario del jugador).",
                        "Corrección del buscador de jugadores.",
                        "Textos del correo mensaje de invitación al club manager (en español).",
                        "Mejoras de diseño Iconos (Club, Team, Player).",
                        "Corrección eliminación de (Club, Team, Player).",
                        "Añadido en listado de clubs (número de equipos).",
                        "Añadido en listado de equipo (número de jugadores).",
                        "Traducción del 20% de la web."
                    ]
                },
                {
                    title: "V0.3",
                    changeList: [
                        "Traducción del 90% de la web al ingles.",
                        "Formulario club manager (nombre, appellidos, telefono).",
                        "Nueva version email de invitación club manager.",
                        "Mejoras de usabilidad y diseño."
                    ]
                },
                {
                    title: "V0.4",
                    changeList: [
                        "Vista información del club, añadido información del manager.",
                        "Vista información del jugador, añadido información del equipo.",
                        "Listado de manager, añadido el club al que pertenece.",
                        "Listado de jugadores, añadido el equipo al que pertenece.",
                        "Al crear un jugador aparece la categoría con el equipo.",
                        "Al crear un jugador aparece el nombre deportivo como obligatorio.",
                        "Corregido el bug de la carga de fotos."
                    ]
                },
                {
                    title: "V0.5",
                    changeList: [
                        "Traducción del 95% de la web.",
                        "Migración de datos.",
                        "Mejoras de rendimiento."
                    ]
                },
                {
                    title: "V0.6",
                    changeList: [
                        "Listado de equipo, buscador mejorado, ya se puede buscar por categoria y club.",
                        "Mejoras de rendimiento.",
                        "Listado de equipo, Importación de jugadores."
                    ]
                },
                {
                    title: "V0.7",
                    changeList: [
                        " Listado de jugadores, ahora se muestra el formato de fecha DD-MM-AAAA ",
                        " Detalles de un jugador, ahora se muestra el formato de fecha DD-MM-AAAA "
                    ]
                },
                {
                    title: "V0.7.1",
                    changeList: [
                        " Tracucción logín, posibilidad de cambiar de idioma en la esquina superior derecha. ",
                        " Tracucción registro manager, posibilidad de cambiar de idioma en la esquina superior derecha. "
                    ]
                },
                {
                    title: "V0.7.2",
                    changeList: [" FIX: Eliminación de un club. "]
                },
                {
                    title: "V0.8",
                    changeList: [
                        " Listado clubs, nueva columna con el numero de jugadores de todos los equipos del club. ",
                        " Ordenación de las columnas del listado de jugadores. ",
                        " Creación de jugadores: fecha de nacimiento dd/mm/yyyy. "
                    ]
                },
                {
                    title: "V0.8.1",
                    changeList: [
                        " Fix importación de jugadores, ahora se permite importar con columnas vacias. "
                    ]
                },
                {
                    title: "V0.9",
                    changeList: [
                        " Creación de delegados desde la vista de un equipo. ",
                        " Creación de entrenadores desde la vista de un equipo. ",
                        " Posibilidad de exportar un pdf del equipo. "
                    ]
                },
                {
                    title: "V0.9.1",
                    changeList: [" Mejoras en la exportación de pdf. "]
                },
                {
                    title: "V0.9.2",
                    changeList: [
                        " Nuevo modulo documentos,todos los documentos se comparten con todos. ",
                        " Mejora en el documento pdf, añadido el logo de la Oviedo cup. "
                    ]
                },
                {
                    title: "V0.9.3",
                    changeList: [
                        " Listado de clubs, posibilidad de buscar por status manager. "
                    ]
                },
                {
                    title: "V0.9.4",
                    changeList: [
                        " Listado de jugadores, añadida la columna del equipo y categoría del jugador. ",
                        " Generación pdf del equipo, eliminado columna telefonos del entrenador y del delegado. "
                    ]
                },
                {
                    title: "V0.9.5",
                    changeList: [" FIX: Listado de jugadores. "]
                },
                {
                    title: "V0.9.6",
                    changeList: [
                        " ADD: listado de entrenadores con buscador por equipo.  ",
                        " ADD: listado de delegados de equipo con buscador por equipo. "
                    ]
                },
                {
                    title: "V0.9.7",
                    changeList: [
                        " ADD: listado de entrenadores y delegados de equipo, añadida la columna de la categoría.  ",
                        " ADD: listado de entrenadores y delegados de equipo, añadida la funcionalidad para exportar como pdf.  ",
                        " ADD: listado de clubs y de equipo, añadido el nº de entrenadores y delegados de equipo. "
                    ]
                },
                {
                    title: "V0.9.9",
                    changeList: [
                        " FIX: Listado de entrenadores  y delegados agrupado por equipo en el pdf exportado.  ",
                    ]
                },
                {
                    title: "V0.9.9.1",
                    changeList: [
                        " FIX: Importación de jugadores desde un excel.",
                    ]
                }
            ]
        };
    },
    computed: {
        ...mapGetters({
            hasRoleToCreateClubs: "entities/club/hasRoleToCreate"
        })
    }
};
</script>

<style scoped>
.version {
    position: absolute;
    color: #909399;
    left: 20px;
    bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/VersionApp/index.vue?4b1ddf82